/*
    Copyright 2022 Dynatrace LLC

    Licensed under the Apache License, Version 2.0 (the "License");
    you may not use this file except in compliance with the License.
    You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

    Unless required by applicable law or agreed to in writing, software
    distributed under the License is distributed on an "AS IS" BASIS,
    WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
    See the License for the specific language governing permissions and
    limitations under the License.
*/

export { DtSpanExporter } from "./export/DtSpanExporter";
export { DtSpanProcessor } from "./export/DtSpanProcessor";
export { DtTextMapPropagator } from "./propagator/DtTextMapPropagator";
export { DtSampler } from "./trace/sampler/DtSampler";

// exports for internal use only
export { ComponentLogger } from "./Logger";
export { addErrorAttributes } from "./utils/ErrorUtils";
export { configureDynatrace } from "./utils/ConfigureDynatrace";
export { DtConfiguration, DtOptions, getConfiguration } from "./configuration/StartupConfig";
export { getPropagatedResourceAttributes, setPropagatedResourceAttributes } from "./export/SpanEmbedder";
export * as SemConvResource from "../gen/dynatrace/odin/semconv/v1/SemConvResource";
export * as SemConvTrace from "../gen/dynatrace/odin/semconv/v1/SemConvTrace";
export { getHttpHeadersToCapture } from "./instrumentation/Headers";
export { Attributes } from "./utils/Compat";
export { dtSuppressTracing } from "./trace/SuppressTracing";
